import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const measureMent = [
  { id: "m", label: "m²" },
  { id: "ft", label: "ft²" },
];
const nameTitle = [
  { id: "0", label: "Mr" },
  { id: "1", label: "Ms" },
  { id: "2", label: "Other" },
];

const genderOption = [
  { id: "0", label: "Male" },
  { id: "1", label: "Female" },
  { id: "2", label: "Other" },
];
// const tenantReleaseStatus = [
//   { id: 0, label: "Outstanding" },
//   { id: 1, label: "Released" },
//   { id: 2, label: "Handed to occupant" },
// ];
const tenantReleaseStatus = [
  { id: 0, label: "Pending" },
  { id: 1, label: "Active" },
  { id: 2, label: "Complete" },
];
const sendCedential = [
  { id: 0, label: "No" },
  { id: 1, label: "Yes" },
];
const calendarDays = [
  { id: 0, label: "Calendar Days" },
  { id: 1, label: "Working Days" },
];
const tenantCoordinator = [
  { id: 0, label: "Coordinator1" },
  { id: 1, label: "Coordinator2" },
];
const tenantGroup = [
  { id: 0, label: "TenantGroup1" },
  { id: 1, label: "TenantGroup2" },
];
const intervalCycle = [
  { id: 0, label: "Day" },
  { id: 1, label: "Week" },
  { id: 2, label: "Month" },
];

const holidayOption = [
  { id: "0", label: "Public Holiday" },
  { id: "1", label: "Builder Holiday" },
];

const timeZoneData = [
  { label: "Europe/Andorra" },
  { label: "Asia/Dubai" },
  { label: "Asia/Kabul" },
  { label: "Europe/Tirane" },
  { label: "Asia/Yerevan" },
  { label: "Antarctica/Casey" },
  { label: "Antarctica/Davis" },
  { label: "Antarctica/DumontDUrville" },
  { label: "Antarctica/Mawson" },
  { label: "Antarctica/Palmer" },
  { label: "Antarctica/Rothera" },
  { label: "Antarctica/Syowa" },
  { label: "Antarctica/Troll" },
  { label: "Antarctica/Vostok" },
  { label: "America/Argentina/Buenos_Aires" },
  { label: "America/Argentina/Cordoba" },
  { label: "America/Argentina/Salta" },
  { label: "America/Argentina/Jujuy" },
  { label: "America/Argentina/Tucuman" },
  { label: "America/Argentina/Catamarca" },
  { label: "America/Argentina/La_Rioja" },
  { label: "America/Argentina/San_Juan" },
  { label: "America/Argentina/Mendoza" },
  { label: "America/Argentina/San_Luis" },
  { label: "America/Argentina/Rio_Gallegos" },
  { label: "America/Argentina/Ushuaia" },
  { label: "Pacific/Pago_Pago" },
  { label: "Europe/Vienna" },
  { label: "Australia/Lord_Howe" },
  { label: "Antarctica/Macquarie" },
  { label: "Australia/Hobart" },
  { label: "Australia/Currie" },
  { label: "Australia/Melbourne" },
  { label: "Australia/Sydney" },
  { label: "Australia/Broken_Hill" },
  { label: "Australia/Brisbane" },
  { label: "Australia/Lindeman" },
  { label: "Australia/Adelaide" },
  { label: "Australia/Darwin" },
  { label: "Australia/Perth" },
  { label: "Australia/Eucla" },
  { label: "Asia/Baku" },
  { label: "America/Barbados" },
  { label: "Asia/Dhaka" },
  { label: "Europe/Brussels" },
  { label: "Europe/Sofia" },
  { label: "Atlantic/Bermuda" },
  { label: "Asia/Brunei" },
  { label: "America/La_Paz" },
  { label: "America/Noronha" },
  { label: "America/Belem" },
  { label: "America/Fortaleza" },
  { label: "America/Recife" },
  { label: "America/Araguaina" },
  { label: "America/Maceio" },
  { label: "America/Bahia" },
  { label: "America/Sao_Paulo" },
  { label: "America/Campo_Grande" },
  { label: "America/Cuiaba" },
  { label: "America/Santarem" },
  { label: "America/Porto_Velho" },
  { label: "America/Boa_Vista" },
  { label: "America/Manaus" },
  { label: "America/Eirunepe" },
  { label: "America/Rio_Branco" },
  { label: "America/Nassau" },
  { label: "Asia/Thimphu" },
  { label: "Europe/Minsk" },
  { label: "America/Belize" },
  { label: "America/St_Johns" },
  { label: "America/Halifax" },
  { label: "America/Glace_Bay" },
  { label: "America/Moncton" },
  { label: "America/Goose_Bay" },
  { label: "America/Blanc-Sablon" },
  { label: "America/Toronto" },
  { label: "America/Nipigon" },
  { label: "America/Thunder_Bay" },
  { label: "America/Iqaluit" },
  { label: "America/Pangnirtung" },
  { label: "America/Atikokan" },
  { label: "America/Winnipeg" },
  { label: "America/Rainy_River" },
  { label: "America/Resolute" },
  { label: "America/Rankin_Inlet" },
  { label: "America/Regina" },
  { label: "America/Swift_Current" },
  { label: "America/Edmonton" },
  { label: "America/Cambridge_Bay" },
  { label: "America/Yellowknife" },
  { label: "America/Inuvik" },
  { label: "America/Creston" },
  { label: "America/Dawson_Creek" },
  { label: "America/Fort_Nelson" },
  { label: "America/Vancouver" },
  { label: "America/Whitehorse" },
  { label: "America/Dawson" },
  { label: "Indian/Cocos" },
  { label: "Europe/Zurich" },
  { label: "Africa/Abidjan" },
  { label: "Pacific/Rarotonga" },
  { label: "America/Santiago" },
  { label: "America/Punta_Arenas" },
  { label: "Pacific/Easter" },
  { label: "Asia/Shanghai" },
  { label: "Asia/Urumqi" },
  { label: "America/Bogota" },
  { label: "America/Costa_Rica" },
  { label: "America/Havana" },
  { label: "Atlantic/Cape_Verde" },
  { label: "America/Curacao" },
  { label: "Indian/Christmas" },
  { label: "Asia/Nicosia" },
  { label: "Asia/Famagusta" },
  { label: "Europe/Prague" },
  { label: "Europe/Berlin" },
  { label: "Europe/Copenhagen" },
  { label: "America/Santo_Domingo" },
  { label: "Africa/Algiers" },
  { label: "America/Guayaquil" },
  { label: "Pacific/Galapagos" },
  { label: "Europe/Tallinn" },
  { label: "Africa/Cairo" },
  { label: "Africa/El_Aaiun" },
  { label: "Europe/Madrid" },
  { label: "Africa/Ceuta" },
  { label: "Atlantic/Canary" },
  { label: "Europe/Helsinki" },
  { label: "Pacific/Fiji" },
  { label: "Atlantic/Stanley" },
  { label: "Pacific/Chuuk" },
  { label: "Pacific/Pohnpei" },
  { label: "Pacific/Kosrae" },
  { label: "Atlantic/Faroe" },
  { label: "Europe/Paris" },
  { label: "Europe/London" },
  { label: "Asia/Tbilisi" },
  { label: "America/Cayenne" },
  { label: "Africa/Accra" },
  { label: "Europe/Gibraltar" },
  { label: "America/Godthab" },
  { label: "America/Danmarkshavn" },
  { label: "America/Scoresbysund" },
  { label: "America/Thule" },
  { label: "Europe/Athens" },
  { label: "Atlantic/South_Georgia" },
  { label: "America/Guatemala" },
  { label: "Pacific/Guam" },
  { label: "Africa/Bissau" },
  { label: "America/Guyana" },
  { label: "Asia/Hong_Kong" },
  { label: "America/Tegucigalpa" },
  { label: "America/Port-au-Prince" },
  { label: "Europe/Budapest" },
  { label: "Asia/Jakarta" },
  { label: "Asia/Pontianak" },
  { label: "Asia/Makassar" },
  { label: "Asia/Jayapura" },
  { label: "Europe/Dublin" },
  { label: "Asia/Jerusalem" },
  { label: "Asia/Kolkata" },
  { label: "Indian/Chagos" },
  { label: "Asia/Baghdad" },
  { label: "Asia/Tehran" },
  { label: "Atlantic/Reykjavik" },
  { label: "Europe/Rome" },
  { label: "America/Jamaica" },
  { label: "Asia/Amman" },
  { label: "Asia/Tokyo" },
  { label: "Africa/Nairobi" },
  { label: "Asia/Bishkek" },
  { label: "Pacific/Tarawa" },
  { label: "Pacific/Enderbury" },
  { label: "Pacific/Kiritimati" },
  { label: "Asia/Pyongyang" },
  { label: "Asia/Seoul" },
  { label: "Asia/Almaty" },
  { label: "Asia/Qyzylorda" },
  { label: "Asia/Qostanay" }, // Added recently
  { label: "Asia/Aqtobe" },
  { label: "Asia/Aqtau" },
  { label: "Asia/Atyrau" },
  { label: "Asia/Oral" },
  { label: "Asia/Vientiane" },
  { label: "Asia/Beirut" },
  { label: "Africa/Monrovia" },
  { label: "Europe/Vilnius" },
  { label: "Europe/Luxembourg" },
  { label: "Asia/Macau" },
  { label: "Europe/Skopje" },
  { label: "Indian/Antananarivo" },
  { label: "Indian/Maldives" },
  { label: "America/Mexico_City" },
  { label: "America/Cancun" },
  { label: "America/Merida" },
  { label: "America/Monterrey" },
  { label: "America/Matamoros" },
  { label: "America/Mazatlan" },
  { label: "America/Chihuahua" },
  { label: "America/Ojinaga" },
  { label: "America/Hermosillo" },
  { label: "America/Tijuana" },
  { label: "America/Bahia_Banderas" },
];

const countryList = [
  { label: "Afghanistan", id: "Afghanistan" },
  { label: "Åland Islands", id: "Åland Islands" },
  { label: "Albania", id: "Albania" },
  { label: "Algeria", id: "Algeria" },
  { label: "American Samoa", id: "American Samoa" },
  { label: "Andorra", id: "Andorra" },
  { label: "Angola", id: "Angola" },
  { label: "Anguilla", id: "Anguilla" },
  { label: "Antarctica", id: "Antarctica" },
  { label: "Antigua & Barbuda", id: "Antigua & Barbuda" },
  { label: "Argentina", id: "Argentina" },
  { label: "Armenia", id: "Armenia" },
  { label: "Aruba", id: "Aruba" },
  { label: "Australia", id: "Australia" },
  { label: "Austria", id: "Austria" },
  { label: "Azerbaijan", id: "Azerbaijan" },
  { label: "Bahamas", id: "Bahamas" },
  { label: "Bahrain", id: "Bahrain" },
  { label: "Bangladesh", id: "Bangladesh" },
  { label: "Barbados", id: "Barbados" },
  { label: "Belarus", id: "Belarus" },
  { label: "Belgium", id: "Belgium" },
  { label: "Belize", id: "Belize" },
  { label: "Benin", id: "Benin" },
  { label: "Bermuda", id: "Bermuda" },
  { label: "Bhutan", id: "Bhutan" },
  { label: "Bolivia", id: "Bolivia" },
  { label: "Bosnia & Herzegovina", id: "Bosnia & Herzegovina" },
  { label: "Botswana", id: "Botswana" },
  { label: "Bouvet Island", id: "Bouvet Island" },
  { label: "Brazil", id: "Brazil" },
  {
    label: "British Indian Ocean Territory",
    id: "British Indian Ocean Territory",
  },
  { label: "British Virgin Islands", id: "British Virgin Islands" },
  { label: "Brunei", id: "Brunei" },
  { label: "Bulgaria", id: "Bulgaria" },
  { label: "Burkina Faso", id: "Burkina Faso" },
  { label: "Burundi", id: "Burundi" },
  { label: "Cambodia", id: "Cambodia" },
  { label: "Cameroon", id: "Cameroon" },
  { label: "Canada", id: "Canada" },
  { label: "Cape Verde", id: "Cape Verde" },
  { label: "Caribbean Netherlands", id: "Caribbean Netherlands" },
  { label: "Cayman Islands", id: "Cayman Islands" },
  { label: "Central African Republic", id: "Central African Republic" },
  { label: "Chad", id: "Chad" },
  { label: "Chile", id: "Chile" },
  { label: "China", id: "China" },
  { label: "Christmas Island", id: "Christmas Island" },
  { label: "Cocos (Keeling) Islands", id: "Cocos (Keeling) Islands" },
  { label: "Colombia", id: "Colombia" },
  { label: "Comoros", id: "Comoros" },
  { label: "Congo - Brazzaville", id: "Congo - Brazzaville" },
  { label: "Congo - Kinshasa", id: "Congo - Kinshasa" },
  { label: "Cook Islands", id: "Cook Islands" },
  { label: "Costa Rica", id: "Costa Rica" },
  { label: "Côte d’Ivoire", id: "Côte d’Ivoire" },
  { label: "Croatia", id: "Croatia" },
  { label: "Cuba", id: "Cuba" },
  { label: "Curaçao", id: "Curaçao" },
  { label: "Cyprus", id: "Cyprus" },
  { label: "Czechia", id: "Czechia" },
  { label: "Denmark", id: "Denmark" },
  { label: "Djibouti", id: "Djibouti" },
  { label: "Dominica", id: "Dominica" },
  { label: "Dominican Republic", id: "Dominican Republic" },
  { label: "Ecuador", id: "Ecuador" },
  { label: "Egypt", id: "Egypt" },
  { label: "El Salvador", id: "El Salvador" },
  { label: "Equatorial Guinea", id: "Equatorial Guinea" },
  { label: "Eritrea", id: "Eritrea" },
  { label: "Estonia", id: "Estonia" },
  { label: "Eswatini", id: "Eswatini" },
  { label: "Ethiopia", id: "Ethiopia" },
  { label: "Falkland Islands", id: "Falkland Islands" },
  { label: "Faroe Islands", id: "Faroe Islands" },
  { label: "Fiji", id: "Fiji" },
  { label: "Finland", id: "Finland" },
  { label: "France", id: "France" },
  { label: "French Guiana", id: "French Guiana" },
  { label: "French Polynesia", id: "French Polynesia" },
  { label: "French Southern Territories", id: "French Southern Territories" },
  { label: "Gabon", id: "Gabon" },
  { label: "Gambia", id: "Gambia" },
  { label: "Georgia", id: "Georgia" },
  { label: "Germany", id: "Germany" },
  { label: "Ghana", id: "Ghana" },
  { label: "Gibraltar", id: "Gibraltar" },
  { label: "Greece", id: "Greece" },
  { label: "Greenland", id: "Greenland" },
  { label: "Grenada", id: "Grenada" },
  { label: "Guadeloupe", id: "Guadeloupe" },
  { label: "Guam", id: "Guam" },
  { label: "Guatemala", id: "Guatemala" },
  { label: "Guernsey", id: "Guernsey" },
  { label: "Guinea", id: "Guinea" },
  { label: "Guinea-Bissau", id: "Guinea-Bissau" },
  { label: "Guyana", id: "Guyana" },
  { label: "Haiti", id: "Haiti" },
  { label: "Heard & McDonald Islands", id: "Heard & McDonald Islands" },
  { label: "Honduras", id: "Honduras" },
  { label: "Hong Kong SAR China", id: "Hong Kong SAR China" },
  { label: "Hungary", id: "Hungary" },
  { label: "Iceland", id: "Iceland" },
  { label: "India", id: "India" },
  { label: "Indonesia", id: "Indonesia" },
  { label: "Iran", id: "Iran" },
  { label: "Iraq", id: "Iraq" },
  { label: "Ireland", id: "Ireland" },
  { label: "Isle of Man", id: "Isle of Man" },
  { label: "Israel", id: "Israel" },
  { label: "Italy", id: "Italy" },
  { label: "Jamaica", id: "Jamaica" },
  { label: "Japan", id: "Japan" },
  { label: "Jersey", id: "Jersey" },
  { label: "Jordan", id: "Jordan" },
  { label: "Kazakhstan", id: "Kazakhstan" },
  { label: "Kenya", id: "Kenya" },
  { label: "Kiribati", id: "Kiribati" },
  { label: "Kuwait", id: "Kuwait" },
  { label: "Kyrgyzstan", id: "Kyrgyzstan" },
  { label: "Laos", id: "Laos" },
  { label: "Latvia", id: "Latvia" },
  { label: "Lebanon", id: "Lebanon" },
  { label: "Lesotho", id: "Lesotho" },
  { label: "Liberia", id: "Liberia" },
  { label: "Libya", id: "Libya" },
  { label: "Liechtenstein", id: "Liechtenstein" },
  { label: "Lithuania", id: "Lithuania" },
  { label: "Luxembourg", id: "Luxembourg" },
  { label: "Macao SAR China", id: "Macao SAR China" },
  { label: "Madagascar", id: "Madagascar" },
  { label: "Malawi", id: "Malawi" },
  { label: "Malaysia", id: "Malaysia" },
  { label: "Maldives", id: "Maldives" },
  { label: "Mali", id: "Mali" },
  { label: "Malta", id: "Malta" },
  { label: "Marshall Islands", id: "Marshall Islands" },
  { label: "Martinique", id: "Martinique" },
  { label: "Mauritania", id: "Mauritania" },
  { label: "Mauritius", id: "Mauritius" },
  { label: "Mayotte", id: "Mayotte" },
  { label: "Mexico", id: "Mexico" },
  { label: "Micronesia", id: "Micronesia" },
  { label: "Moldova", id: "Moldova" },
  { label: "Monaco", id: "Monaco" },
  { label: "Mongolia", id: "Mongolia" },
  { label: "Montenegro", id: "Montenegro" },
  { label: "Montserrat", id: "Montserrat" },
  { label: "Morocco", id: "Morocco" },
  { label: "Mozambique", id: "Mozambique" },
  { label: "Myanmar (Burma)", id: "Myanmar (Burma)" },
  { label: "Namibia", id: "Namibia" },
  { label: "Nauru", id: "Nauru" },
  { label: "Nepal", id: "Nepal" },
  { label: "Netherlands", id: "Netherlands" },
  { label: "New Caledonia", id: "New Caledonia" },
  { label: "New Zealand", id: "New Zealand" },
  { label: "Nicaragua", id: "Nicaragua" },
  { label: "Niger", id: "Niger" },
  { label: "Nigeria", id: "Nigeria" },
  { label: "Niue", id: "Niue" },
  { label: "Norfolk Island", id: "Norfolk Island" },
  { label: "North Korea", id: "North Korea" },
  { label: "North Macedonia", id: "North Macedonia" },
  { label: "Northern Mariana Islands", id: "Northern Mariana Islands" },
  { label: "Norway", id: "Norway" },
  { label: "Oman", id: "Oman" },
  { label: "Pakistan", id: "Pakistan" },
  { label: "Palau", id: "Palau" },
  { label: "Palestinian Territories", id: "Palestinian Territories" },
  { label: "Panama", id: "Panama" },
  { label: "Papua New Guinea", id: "Papua New Guinea" },
  { label: "Paraguay", id: "Paraguay" },
  { label: "Peru", id: "Peru" },
  { label: "Philippines", id: "Philippines" },
  { label: "Pitcairn Islands", id: "Pitcairn Islands" },
  { label: "Poland", id: "Poland" },
  { label: "Portugal", id: "Portugal" },
  { label: "Puerto Rico", id: "Puerto Rico" },
  { label: "Qatar", id: "Qatar" },
  { label: "Réunion", id: "Réunion" },
  { label: "Romania", id: "Romania" },
  { label: "Russia", id: "Russia" },
  { label: "Rwanda", id: "Rwanda" },
  { label: "Samoa", id: "Samoa" },
  { label: "San Marino", id: "San Marino" },
  { label: "São Tomé & Príncipe", id: "São Tomé & Príncipe" },
  { label: "Saudi Arabia", id: "Saudi Arabia" },
  { label: "Senegal", id: "Senegal" },
  { label: "Serbia", id: "Serbia" },
  { label: "Seychelles", id: "Seychelles" },
  { label: "Sierra Leone", id: "Sierra Leone" },
  { label: "Singapore", id: "Singapore" },
  { label: "Sint Maarten", id: "Sint Maarten" },
  { label: "Slovakia", id: "Slovakia" },
  { label: "Slovenia", id: "Slovenia" },
  { label: "Solomon Islands", id: "Solomon Islands" },
  { label: "Somalia", id: "Somalia" },
  { label: "South Africa", id: "South Africa" },
  {
    label: "South Georgia & South Sandwich Islands",
    id: "South Georgia & South Sandwich Islands",
  },
  { label: "South Korea", id: "South Korea" },
  { label: "South Sudan", id: "South Sudan" },
  { label: "Spain", id: "Spain" },
  { label: "Sri Lanka", id: "Sri Lanka" },
  { label: "St. Barthélemy", id: "St. Barthélemy" },
  { label: "St. Helena", id: "St. Helena" },
  { label: "St. Kitts & Nevis", id: "St. Kitts & Nevis" },
  { label: "St. Lucia", id: "St. Lucia" },
  { label: "St. Martin", id: "St. Martin" },
  { label: "St. Pierre & Miquelon", id: "St. Pierre & Miquelon" },
  { label: "St. Vincent & Grenadines", id: "St. Vincent & Grenadines" },
  { label: "Sudan", id: "Sudan" },
  { label: "Suriname", id: "Suriname" },
  { label: "Svalbard & Jan Mayen", id: "Svalbard & Jan Mayen" },
  { label: "Sweden", id: "Sweden" },
  { label: "Switzerland", id: "Switzerland" },
  { label: "Syria", id: "Syria" },
  { label: "Taiwan", id: "Taiwan" },
  { label: "Tajikistan", id: "Tajikistan" },
  { label: "Tanzania", id: "Tanzania" },
  { label: "Thailand", id: "Thailand" },
  { label: "Timor-Leste", id: "Timor-Leste" },
  { label: "Togo", id: "Togo" },
  { label: "Tokelau", id: "Tokelau" },
  { label: "Tonga", id: "Tonga" },
  { label: "Trinidad & Tobago", id: "Trinidad & Tobago" },
  { label: "Tunisia", id: "Tunisia" },
  { label: "Turkey", id: "Turkey" },
  { label: "Turkmenistan", id: "Turkmenistan" },
  { label: "Turks & Caicos Islands", id: "Turks & Caicos Islands" },
  { label: "Tuvalu", id: "Tuvalu" },
  { label: "Uganda", id: "Uganda" },
  { label: "Ukraine", id: "Ukraine" },
  { label: "United Arab Emirates", id: "United Arab Emirates" },
  { label: "United Kingdom", id: "United Kingdom" },
  { label: "United States", id: "United States" },
  { label: "Uruguay", id: "Uruguay" },
  { label: "Uzbekistan", id: "Uzbekistan" },
  { label: "Vanuatu", id: "Vanuatu" },
  { label: "Vatican City", id: "Vatican City" },
  { label: "Venezuela", id: "Venezuela" },
  { label: "Vietnam", id: "Vietnam" },
  { label: "Wallis & Futuna", id: "Wallis & Futuna" },
  { label: "Western Sahara", id: "Western Sahara" },
  { label: "Yemen", id: "Yemen" },
  { label: "Zambia", id: "Zambia" },
  { label: "Zimbabwe", id: "Zimbabwe" },
];

const folderTypesMatch = [
  {
    id: 1,
    name: "Folder",
    icon: (
      <InnoIcons.FolderIcon
        sx={{
          marginRight: "5px",
          width: "20px",
          height: "20px",
          color: theme.colors.themeColor,
        }}
      />
    ),
  },
  {
    id: 2,
    name: "Document",
    icon: (
      <InnoIcons.DescriptionOutlinedIcon
        sx={{
          marginRight: "5px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 3,
    name: "Address Book",
    icon: (
      <InnoIcons.AutoStoriesOutlinedIcon
        sx={{
          marginRight: "5px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 4,
    name: "Journal",
    icon: (
      <InnoIcons.MenuBookOutlinedIcon
        sx={{
          marginRight: "5px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 5,
    name: "Cart",
    icon: (
      <InnoIcons.ShoppingCartOutlinedIcon
        sx={{
          marginRight: "5px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 6,
    name: "Home",
    icon: (
      <InnoIcons.HomeOutlinedIcon
        sx={{
          marginRight: "5px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 7,
    name: "Occupant Info",
    icon: (
      <InnoIcons.InfoOutlinedIcon
        sx={{
          marginRight: "5px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 11,
    name: "Photos & Videos",
    icon: (
      <InnoIcons.AddPhotoAlternateIcon
        sx={{
          marginRight: "5px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
];

const movefolderTypesMatch = [
  {
    id: 1,
    name: "Folder",
    icon: (
      <InnoIcons.FolderIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          color: theme.colors.themeColor,
        }}
      />
    ),
  },
  {
    id: 2,
    name: "Document",
    icon: (
      <InnoIcons.DescriptionOutlinedIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 3,
    name: "Address Book",
    icon: (
      <InnoIcons.AutoStoriesOutlinedIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 4,
    name: "Journal",
    icon: (
      <InnoIcons.MenuBookOutlinedIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 5,
    name: "Cart",
    icon: (
      <InnoIcons.ShoppingCartOutlinedIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 6,
    name: "Home",
    icon: (
      <InnoIcons.HomeOutlinedIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 7,
    name: "Occupant Info",
    icon: (
      <InnoIcons.InfoOutlinedIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
];

const folderTypes = [
  {
    id: 1,
    name: "Folder",
    icon: (
      <InnoIcons.FolderIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          color: theme.colors.themeColor,
        }}
      />
    ),
  },
  {
    id: 2,
    name: "Document",
    icon: (
      <InnoIcons.DescriptionOutlinedIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },
  {
    id: 11,
    name: "Photos",
    icon: (
      <InnoIcons.PhotoLibraryIcon
        sx={{
          marginRight: "8px",
          width: "20px",
          height: "20px",
          opacity: "0.8",
        }}
      />
    ),
  },

  // {
  //   id: 5,
  //   name: "Cart",
  //   icon: <span style={{ marginRight: "8px", fontSize: "18px" }}>🛒</span>,
  // },
  // {
  //   id: 6,
  //   name: "Home",
  //   icon: <span style={{ marginRight: "8px", fontSize: "18px" }}>🏠</span>,
  // },
];

const folderOrder = [
  { id: 1, order: 1 },
  { id: 2, order: 2 },
  { id: 3, order: 3 },
  { id: 4, order: 4 },
  { id: 5, order: 5 },
  { id: 6, order: 6 },
  { id: 7, order: 7 },
  { id: 8, order: 8 },
  { id: 9, order: 9 },
  { id: 10, order: 10 },
  { id: 11, order: 11 },
  { id: 12, order: 12 },
  { id: 13, order: 13 },
  { id: 14, order: 14 },
  { id: 15, order: 15 },
  { id: 16, order: 16 },
  { id: 17, order: 17 },
  { id: 18, order: 18 },
  { id: 19, order: 19 },
  { id: 20, order: 20 },
];

const privacyOption = [
  { id: "0", label: "Public" },
  { id: "1", label: "Private" },
];
const submitOption = [
  { id: 0, label: "Notify with document attached" },
  { id: 1, label: "Notify only" },
  { id: 2, label: "Submit only" },
];

const requestType = [
  {
    id: 1,
    label: "No request",
  },
  {
    id: 2,
    label: "Include in report",
  },
  {
    id: 3,
    label: "1st Request",
  },
];

// export const requestStatus = {
//   1: "No request",
//   2: "Include in report",
//   3: "1st Request",
// };

const timeTosend = [
  {
    id: 1,
    label: "08:00 AM",
  },
  {
    id: 2,
    label: "08:30 AM",
  },
  {
    id: 3,
    label: "09:00 AM",
  },
  {
    id: 4,
    label: "09:30 AM",
  },
  {
    id: 5,
    label: "10:00 AM",
  },
  {
    id: 6,
    label: "10:30 AM",
  },
  {
    id: 7,
    label: "11:00 AM",
  },
  {
    id: 8,
    label: "11:30 AM",
  },
  {
    id: 9,
    label: "12:00 PM",
  },
  {
    id: 10,
    label: "12:30 PM",
  },
  {
    id: 11,
    label: "01:00 PM",
  },
  {
    id: 12,
    label: "01:30 PM",
  },
  {
    id: 13,
    label: "02:00 PM",
  },
  {
    id: 14,
    label: "02:30 PM",
  },
  {
    id: 15,
    label: "03:00 PM",
  },
  {
    id: 16,
    label: "03:30 PM",
  },
  {
    id: 17,
    label: "04:00 PM",
  },
  {
    id: 18,
    label: "04:30 PM",
  },
  {
    id: 19,
    label: "05:00 PM",
  },
];

const saveOptionData = [
  { id: 0, label: "Save journal and send" },
  { id: 1, label: "Save to Journal" },
];
const sendTypeOption = [
  /* { id: 0, label: "Cart Attached" },
  { id: 1, label: "Bulk Send" }, */
  { id: 2, label: "Send download link-no login required to download" },
  { id: 3, label: "Send download link-login required to download" },
  { id: 4, label: "Send as attachments" },
];

const requestTypeForUpdate = [
  {
    id: 1,
    label: "No request",
  },
  {
    id: 2,
    label: "Include in report",
  },
  {
    id: 3,
    label: "1st Request",
  },
  {
    id: 4,
    label: "2nd Request",
  },
  {
    id: 5,
    label: "3rd Request",
  },
  {
    id: 6,
    label: "4th Request",
  },
  {
    id: 7,
    label: "5th Request",
  },
  {
    id: 8,
    label: "6th Request",
  },
  {
    id: 9,
    label: "7th Request",
  },
  {
    id: 10,
    label: "8th Request",
  },
  {
    id: 11,
    label: "9th Request",
  },
  {
    id: 12,
    label: "10th Request",
  },
  {
    id: 13,
    label: "Final Request",
  },
];

const selectSortType = [
  { id: 1, label: "Occupant Number" },
  { id: 2, label: "Occupant Name" },
  { id: 3, label: "Co-ordinator" },
  { id: 4, label: "Occupant Area" },
  { id: 5, label: "BO Period" },
  { id: 6, label: "BO Date" },
];

const sortTypeLookup = {
  shopNumber: 1,
  shopName: 2,
  tenantCoordinator: 3,
  shopArea: 4,
  boPeriod: 5,
  boDate: 6,
  boNotificationPeriod: 7,
  boNotificationDate: 8,
};

const orderOption = [
  { id: 0, label: "Ascending" },
  { id: 1, label: "Descending" },
];
const orderOptionLookup = {
  ascending: 0,
  descending: 1,
};
const addOnLabel = [
  { id: 0, label: "Include Requests" },
  { id: 1, label: "Exclude Hyperlink" },
];
const addOnLabelLookup = {
  includeRequests: 0,
  excludeHyperlink: 1,
};

const selectTimeframe = [
  { id: 1, label: "7 Days" },
  { id: 2, label: "14 Days" },
  { id: 3, label: "30 Days" },
  { id: 4, label: "45 Days" },
  { id: 5, label: "60 Days" },
];

const selectTimeframeLookup = {
  "7days": 1,
  "14days": 2,
  "30days": 3,
  "45days": 4,
  "60days": 5,
};

const userAccess = {
  canEditProject: true,
  canLinkHolidayToProject: true,
  canAddUserToProject: true,
  canAddLevel: true,
  canEditLevel: true,
  canAddOccupant: true,
  canEditOccupant: true,
  canManageProjectTemplate: true,
  canEditUser: false,
  canAssignRoles: true,
  canManageUserProject: false,
  canSendUserCredential: false,
  canRemoveUsersFromProject: false,
  canManageMainFolderTemplate: true,
  canManageCompany: true,
  canManageHolidays: true,
};

const fileTypeOptions = [
  { id: "image/vnd.dwg", label: "DWG" },
  { id: "image/png", label: "PNG" },
  { id: "image/jpeg", label: "JPEG" },
  { id: "image/jpg", label: "JPG" },
  { id: "image/gif", label: "GIF" },
  { id: "image/svg+xml", label: "SVG" },
  { id: "application/pdf", label: "PDF" },
  { id: "application/msword", label: "DOC" },
  {
    id: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    label: "DOCX",
  },
  { id: "application/vnd.ms-excel", label: "XLS" },
  {
    id: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    label: "XLSX",
  },
  { id: "application/vnd.ms-powerpoint", label: "PPT" },
  {
    id: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    label: "PPTX",
  },
  { id: "text/plain", label: "TXT" },
  { id: "application/zip", label: "ZIP" },
  { id: "application/x-rar-compressed", label: "RAR" },
];

export {
  nameTitle,
  genderOption,
  sendCedential,
  timeZoneData,
  holidayOption,
  tenantReleaseStatus,
  calendarDays,
  intervalCycle,
  measureMent,
  tenantCoordinator,
  tenantGroup,
  countryList,
  folderTypes,
  folderOrder,
  privacyOption,
  submitOption,
  requestType,
  timeTosend,
  saveOptionData,
  sendTypeOption,
  requestTypeForUpdate,
  selectSortType,
  sortTypeLookup,
  orderOption,
  orderOptionLookup,
  addOnLabel,
  addOnLabelLookup,
  selectTimeframe,
  selectTimeframeLookup,
  folderTypesMatch,
  movefolderTypesMatch,
  userAccess,
  fileTypeOptions,
};
